import register from '@/components/features/cms/blocks/BuyButton/register';
import { BuyButton } from './BuyButton';

register(BuyButton);
